<template>
  <b-form v-on:submit.prevent="submit()" validated novalidate>
    <b-card>
      <div slot="header">
        {{title}}
      </div>
      <b-card-body>
        <b-form-group label-for="FirstName" label="First Name">
          <b-form-input type="text" v-model="adForm.firstName" class="form-control-warning" id="FirstName" required></b-form-input>
          <b-form-valid-feedback>
            Valid first name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter users first name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="LastName" label="Last Name">
          <b-form-input type="text" v-model="adForm.lastName" class="form-control-warning" id="LastName" required></b-form-input>
          <b-form-valid-feedback>
            Valid last name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter users last name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Cell" label="Cell">
          <b-form-input type="text" v-model="adForm.cell" class="form-control-warning" id="Cell"></b-form-input>
        </b-form-group>
        <b-form-group label-for="Email" label="Email">
          <b-form-input type="text" v-model="adForm.email" class="form-control-warning" id="Email" required></b-form-input>
          <b-form-valid-feedback>
            Valid email provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter users email.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="Password" label="Password" v-if="!isEdit">
          <b-form-input type="password" v-model="adForm.password" class="form-control-warning" id="Password" required></b-form-input>
          <b-form-valid-feedback>
            Valid password provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter users password.
          </b-form-invalid-feedback>
        </b-form-group>
        <Allocation :adForm="adForm" :hideCompany="hideCompany" :hideRegion="true" :isEdit="isEdit"></Allocation>
        <b-form-group label-for="MacAddress" label="MAC Address">
          <b-form-input type="text" :disabled="true" v-model="adForm.macAddress" class="form-control-warning" id="MacAddress" required></b-form-input>
        </b-form-group>
        <b-form-group label-for="Roles" label="Roles">
          <b-form-checkbox v-model="adForm.isUser">User</b-form-checkbox>
          <b-form-checkbox v-model="adForm.isAdmin" v-if="isAdmin || isSuperAdmin">Admin</b-form-checkbox>
          <b-form-checkbox v-model="adForm.isSuperAdmin" v-if="isSuperAdmin">Super Admin</b-form-checkbox>
        </b-form-group>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/admin/users/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-card>
  </b-form>
</template>
<script>
import axios from 'axios'
import filter from './../../../mixins/filter'
import Allocation from '@/views/admin/Allocation'

export default {
  name: 'formuser',
  components: {
    Allocation
  },
  data () {
    return {
      adForm: {},
      companies: []
    }
  },
  mixins: [filter],
  props: ['title','form','mode'],
  computed: {
    companyList: function () {
      return this.companies.map((company) => {
        return {
          text: company.name,
          value: company._id
        }
      })
    },
    isEdit: function () {
      return this.mode === 'edit'
    },
    isAdmin () {
      return this.$store.getters.isAdmin;
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin;
    }
  },
  methods: {
    send () {
      if(!this.adForm.firstName) {
        console.log('invalid')
        return
      }

      if(!this.adForm.lastName) {
        console.log('invalid')
        return
      }

      if(!this.adForm.email) {
        console.log('invalid')
        return
      }

      if(!this.isEdit && !this.adForm.password) {
        console.log('invalid')
        return
      }

      if(!this.adForm.company) {
        console.log('invalid')
        return
      }

      if(!this.adForm.macAddress) {
        console.log('invalid')
        return
      }

      this.$emit('submit', this.adForm);
    },
    submit: function () {
      if(!this.isEdit) {
        this.adForm.isAdmin = true;
        this.generateMacAddress();
      } else {
        this.send();
      }
    },
    generateMacAddress () {
      let scope = this;
      this.$store.dispatch('generateMacAddress').then(result => {
        if(result.user === null) {
          scope.adForm.macAddress = result.macAddress;
          this.send();
        } else {
          console.log(`MAC Address ${result.macAddress} not unique. Trying again.`);
          this.generateMacAddress();
        }
      }, error => {
        console.log(error);
      });
    }
  },
  created () {
    if(!this.isEdit) {
      this.adForm = this.form;
    }
  },
  watch: {
    form (val) {
      this.adForm = this.form;
      if(this.adForm.region === undefined) {
        this.adForm.region = null;
      }
      if(this.adForm.branch === undefined) {
        this.adForm.branch = null;
      }
      if(this.adForm.device === undefined) {
        this.adForm.device = null;
      }
    }
  }
}
</script>